<template>
  <div class="Hdr-User-Menu" ref="dropdown">
    <button class="Hdr-User-Menu__avatar" @click="toToggleMenu()">
      <AvatarBorder :src="get_avatar" :alt="get_name" :size="36" />
    </button>
    <transition name="Anim__fadeUp">
      <DropMenuUser class="Hdr-User-Menu__dropdown" @close="toToggleMenu(false)" v-if="isOpen" />
    </transition>
  </div>
</template>

<script setup>
  import { ref, computed } from 'vue';
  import { useStore } from 'vuex';
  //-----------------------
  import AvatarImage from '@shared/UI/Images/AvatarImage/AvatarImage.vue';
  import AvatarBorder from '@shared/UI/Images/AvatarBorder/AvatarBorder.vue';
  import DropMenuUser from '@features/DropMenu/modules/DropMenuUser/DropMenuUser.vue';
  //------------------------
  const store = useStore();
  //------------------------
  const isOpen = ref(false);
  const dropdown = ref(null);
  //------------------------
  const USER_SYSTEM = store.state.UserSystem;
  //------------------------
  //Получить аватарку пользователя
  const get_avatar = computed(() => USER_SYSTEM.user.avatar);
  //Получить имя пользователя
  const get_name = computed(() => USER_SYSTEM.user.username);
  //------------------------
  //Открыть/закрыть меню
  const toToggleMenu = (status) => {
    isOpen.value = status ? status : !isOpen.value;
    !isOpen.value ? removeClickEvent() : addClickEvent();
  };
  //Закрыть меню при клике вне дропдауна
  const handleClickOutside = (e) => {
    if(!dropdown.value || dropdown.value.contains(e.target) || e.target.closest('svg')) return;
    toToggleMenu(false);
  }
  //Добавить общий слушатель кликов
  const addClickEvent = () => {
    document.addEventListener('click', handleClickOutside);
  }
  //Удалить общий слушатель кликов
  const removeClickEvent = () => {
    document.removeEventListener('click', handleClickOutside);
  }
</script>

<style lang="scss">
  @import "./styles/_conf";
</style>
